export default __webpack_public_path__ + "static/media/4.cd3eb806.png";